import { underlineLinkStyle } from './shared-styles-from-theme-fluent';

export const deliveryStatusStyle = ({ palette = {} }) => ({
  '#rejectionContainer .popover-view.rejection-reason-container': {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
    padding: '24px 16px',
    width: 300,
  },
  '#contextual-attribute': {
    maxWidth: '350px',
    '& .popover-title': {
      padding: 'unset',
    },
    '& .popover-content': {
      padding: 'unset',
      '& .contextual-content': {
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '5px',
        paddingBottom: '5px',
        '& div.urlContainer': {
          display: 'flex',
        },
        '& div': {
          fontFamily: 'inherit',
          fontWeight: 'inherit',
          lineHeight: '1.1',
          color: '#323130',
          paddingTop: '5px',
          paddingBottom: '5px',
          fontSize: '12px',
          '& .iconba-Warning': {
            marginLeft: '5px',
            marginRight: '5px',
            color: '#D83B01',
          },
          '& .iconba-Completed': {
            marginLeft: '5px',
            marginRight: '5px',
            color: '#107C10',
          },
          '& .line-height-normal': {
            lineHeight: 'normal',
          },
          '& span.url': {
            maxWidth: '100%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
          '& .labelItem': {
            fontWeight: '600',
          },
        },
        '& .moreImages': {
          display: 'flex',
          flexDirection: 'column',
          paddingLeft: 6,
          paddingTop: 11,
          paddingBottom: 3,
          paddingRight: 6,
          '&.image': {
            minHeight: 120,
          },
          '& img': {
            marginBottom: 7,
          },
          '& .viewMore': {
            cursor: 'pointer',
            color: '#0078D4',
          },
        },
        '& .clarityEventGoalSettingsContainer': {
          '& #clarityEventButtonText': {
            fontWeight: 'bold',
          },
          '& .clarityEventGoalSettings': {
            paddingBottom: 'unset',
          },
          '& .sourceURL': {
            paddingTop: 'unset',
            wordBreak: 'break-all',
          },
        },
        '& .importedTaskItem': {
          minWidth: 308,
          '& #title': {
            fontWeight: 'bold',
          },
          '& .createdBy': {
            '& div': {
              paddingBottom: 0,
              paddingTop: 0,
            },
          },
          '& p': {
            display: 'inline',
          },
        },
        '& .campaigns': {
          minWidth: 213,
          '& .title': {
            fontWeight: 'bold',
          },
        },
      },
      '& .popover-paged-content__pager': {
        margin: 'unset',
      },
    },
  },
  '#delivery-status-popup-callout,.delivery-status-popup-callout': {
    width: '450px',
    maxWidth: '450px',
    '& .popover-paged-content__body > .popover-content': {
      padding: 0,
      paddingTop: '18px',
      '& .editorialHeader': {
        padding: 0,
        color: '#848484',
        whiteSpace: 'nowrap',
      },
      '& .contextual-content': {
        '& div': {
          fontFamily: 'inherit',
          fontWeight: '600',
          lineHeight: '1.1',
          color: 'inherit',
          marginTop: '10.5px',
          marginBottom: '10.5px',
          fontSize: '14px',
          '& .iconba-Warning': {
            marginLeft: '5px',
            marginRight: '5px',
            color: '#D83B01',
          },
          '& .iconba-Completed': {
            marginLeft: '5px',
            marginRight: '5px',
            color: '#107C10',
          },
        },
      },
    },
    '& > .popover-title': {
      paddingBottom: 0,
    },
    '& .reason': {
      color: '#444444',
      wordWrap: 'break-word',
      paddingRight: 0,
    },
    '& .new-editorial-popup': {
      '& .iconba-ErrorBadge': {
        color: '#A80000',
      },
      '& .iconba-Warning': {
        color: '#A80000',
      },
      '& .popup-header': {
        '& span': {
          fontFamily: 'Segoe UI',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '20px',
          lineHeight: '28px',
        },
        marginBottom: '20px',
      },
      '& .country-list': {
        display: 'none',
        maxHeight: 100,
        overflowY: 'auto',
        border: '1px solid',
        marginTop: 8,
      },
      '& .toggle-country-list.icon': {
        paddingLeft: 8,
        fontFamily: '"MsAds MDL2 Assets"',
      },
      '& .editorial-reason': {
        marginBottom: '12px',
        '& .violation': {
          fontFamily: 'Segoe UI',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: '16px',
          marginLeft: '8px',
        },
        '& .detection-rejection': {
          marginTop: 8,
          fontSize: 14,
        },
        '& .detection-label, & .rejection-label': {
          fontWeight: '600',
        },
        '& .detection-label': {
          paddingLeft: 22,
        },
        '& .rejection-label': {
          paddingLeft: 15,
        },
      },
      '& ul': {
        listStyle: 'disc',
        paddingLeft: 'revert',
      },
      '& ul li span': {
        fontFamily: 'Segoe UI',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
      },
      '& a[href^="http"]': {
        textDecoration: 'none',
      },
      '& .popup-footer': {
        fontFamily: 'Segoe UI',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '16px',
      },
    },
    '& .request-permission-custom-template': {
      '& button#requestLinkedInPermission': {
        display: 'block',
        fontSize: '14px',
        color: '#ffffff',
        backgroundColor: '#0f6cbd',
        border: 'none',
        borderRadius: '4px',
        padding: '8px 12px',
        margin: '6px 0',

        '&:hover': { backgroundColor: '#115ea3' },
        '&:active': { backgroundColor: '#0c3b5e' },
      },
    },
    ...underlineLinkStyle({ palette, elementLocator: 'a, .btn-link.HelpTopic' }),
    '& a.disabled': {
      cursor: 'not-allowed',
      'pointer-events': 'none',
      color: palette.neutralTertiary,
    },
  },
  '#rejectionContainer, #delivery-status-popup-callout': {
    '& .popover-paged-content__pager': {
      marginTop: 10,
      '& #gridPopup-Pager-prev': {
        display: 'inline-flex',
        '& #gridPopup-Pager-cur': {
          marginRight: '5px',
        },
        '& #gridPopup-Pager-tot': {
          marginLeft: '5px',
        },
      },
      '& #gridPopup-Pager-next': {
        display: 'inline-block',
      },
    },
    '& .grid-previous, & .grid-previous-disabled, & .grid-next, & .grid-next-disabled': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 14,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .grid-previous:before, & .grid-previous-disabled:before': {
      content: '"\\E973"',
      marginRight: '10px',
    },
    '& .grid-next:before, & .grid-next-disabled:before': {
      content: '"\\E974"',
      marginLeft: '10px',
    },
    '& .grid-next:before, & .grid-previous:before': {
      color: palette.neutralSecondary,
    },
    '& .grid-previous-disabled:before, & .grid-next-disabled:before': {
      color: '#BEBBB8',
    },
  },
});
